import { colors2 } from "oolib";

export const scrollToElement = ({ scrollIntoViewElemId }) => {
  setTimeout(() => {
    let element = document.querySelector(`[data-valuepath="${scrollIntoViewElemId}"]`);
    if (!element) {
      element = document.getElementById(scrollIntoViewElemId);
    }
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });

      // briefly highlight the annotation then fade back
      const originalBg = element.style.backgroundColor;
      const originalTransition = element.style.transition;
      element.style.transition = "background-color 0.3s ease-out";
      element.style.backgroundColor = colors2.blue;
      setTimeout(() => {
        element.style.backgroundColor = originalBg;
        setTimeout(() => {
          element.style.transition = originalTransition;
        }, 300);
      }, 1000);
    }
  }, 100);
};
